module.exports = __webpack_public_path__ + "static/media/faqBalance-es-pt.e0a550ba.vtt";